<template>
  <svg class="icon">
    <use :href="`#ico-${name}`" />
  </svg>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'SvgIcon',
    props: {
      name: {
        type: String,
        required: true,
      },
    }
  })
</script>
